import React from 'react'
import styled from '@emotion/styled'
import TextLockup from 'src/components/TextLockup'
import TextLink from 'src/components/TextLink'
import Image from 'src/components/Image'
import RawVideo from 'src/components/Video/RawVideo'
import List from 'src/components/List'
import NewsletterSignup from 'src/components/NewsletterSignup'
import Button from 'src/components/Button'
import Card from 'src/components/Card'
import ScrollEntrance from 'src/components/ScrollEntrance'
import ShoppableImage from 'src/components/ShoppableImage'
import Accordion from 'src/components/Accordion'
import ContactForm from 'src/components/ContactForm'
import { util, colors } from 'src/styles'

const componentMap = {
	ContentfulText: TextLockup,
	ContentfulShoppableImage: ShoppableImage,
	ContentfulContactForm: ContactForm,
	ContentfulLink: {
		default: TextLink,
		textLink: TextLink,
		button: Button
	},
	ContentfulImage: Image,
	ContentfulVideo: RawVideo,
	ContentfulList: {
		default: List,
		horizontal: List,
		vertical: List,
		checkList: List
  },
  ContentfulNewsletterSignup: NewsletterSignup,
  ContentfulAccordion: Accordion
}

const ColumnContent = styled.div`
	> div {
	  &:not(:first-of-type) {
	  	${ util.responsiveStyles('margin-top', 24, 20, 18, 16) }
	  }
  }
  ${ ({ type }) => type.startsWith('card') ? `
  	${ util.responsiveStyles('padding', 60, 50, 40, 16) }
  	height: 100%;
  ` : `` }

  ${ ({ type }) => type === 'card CTA' ? `
  	h1, h2, h3, h4 {
  		margin: 0;
  	}
  	h3 {
  		color: ${ colors.blue };
  	}
  ` : `` }
`

const RenderContent = ({ items, delay }) => {
	return (
		items.map((item, index) => {
			let Component = componentMap[item.__typename]
			if (item.type || item.type === null) {
				Component = componentMap[item.__typename][item.type]
				if (!Component) {
					Component = componentMap[item.__typename].default
				}
			}
			return Component ? (
				<ScrollEntrance
					key={item.id}
					delay={index + delay}
					transitionIn={item.__typename !== 'ContentfulText'}
				>
					<div>
						<Component
							{...item}
							delay={index + delay}
							entranceDelay={index + delay}
						/>
					</div>
				</ScrollEntrance>
			) : false
		})
	)
}

const Column = ({ items, delay, type }) => {
	if (!items) {
		return false
	}

	if (type === null) {
		type = 'default'
	}

	return (
		<ColumnContent as={type.startsWith('card') ? Card : 'div'} type={type}>
			<RenderContent items={items} delay={delay}/>
		</ColumnContent>
	)
}

Column.defaultProps = {
	type: 'default'
}

export default Column
